module.exports = __webpack_public_path__ + "static/media/profile.d05e41a2.jpg";